import { connect } from 'react-redux';
import Employment from "../../../../components/admin/riaContacts/acordionSections/Employment";

const mapStateToProps = (state) => {
  return {
    adminUserSession: state.adminLogin.adminUserSession,
  }
}

const EmploymentContainer = connect(mapStateToProps, {})(Employment)

export default EmploymentContainer;